<template>
  <div class="card__item">
    <van-checkbox
      icon-size="18px"
      checked-color="#F40442"
      v-model="checked"
      style="padding:0 10px 0 16px"
    ></van-checkbox>
    <van-swipe-cell style="width:100%" :before-close="beforeClose">
      <div class="goods">
        <div class="goods_header" @click="onNavigate(pid)">
          <img :src="thumb" width="42" height="42" class="goods_img">
          <div class="goods_name">{{title}}</div>
        </div>
        <div class="good_sku">已选: {{pdescription}}*{{unitNumber}}</div>
        <div class="goods_footer">
          <div class="goods_price">
            ￥{{price}}
          </div>
          <div class="goods_num">
            <van-stepper @change='changeNum' v-model.number="nums" integer min="1"/>
          </div>
        </div>
      </div>
      <template #right>
        <van-button square text="删除" type="danger" style="height:100%;width: 60px"/>
      </template>
    </van-swipe-cell>
  </div>
</template>

<script>
  //验证是否为数字
   function isNumber(value) {
    var patrn = /^(-)?\d+(\.\d+)?$/;
    if (patrn.exec(value) == null || value == "") {
      return false
    } else {
      return true
    }
  }
  import { updateCartPrice } from '@/api/cart'
  export default {
    model: {
      prop: 'isChecked'
    },
    props: {
      index: Number,
      id: Number,
      pid: String,
      thumb: String,
      title: String,
      desc: String,
      tag: String,
      pdescription: String,
      tags: Array,
      originPrice: Number,
      price: Number,
      num: Number,
      unitNumber: {
        type: Number,
        default: 0
      },
      isChecked: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      checked: {
        get() {
          return this.isChecked
        },
        set(val) {
          this.$emit('input', { val, idx: this.index })
        }
      }
    },
    data(){
      return{
        nums:''
      }
    },
    watch: {
      num(newval){
        this.nums = newval
      }
    },
    created(){
      this.nums = this.num
    },
    methods: {

      onNavigate(id) {
        this.$router.push({
          path: '/product/detail',
          query: { id: id }
        })
      },
      //加减按钮是触发获取当前num值
      changeNum(nums){
        if (isNumber(nums) && nums > 100000000){
          this.$toast({
            message: '最大数量不能超过 100000000',
            duration: 1500
          })
          return;
        }
        if(!isNumber(nums) || nums <= 0){
          this.$toast.fail("数量必须大于0");
          return;
        }else{
          this.updateCartPrice(this.id,nums)
        }
      },
      updateCartPrice(id,number){
        var user = localStorage.getItem('userInfo')
        if (!user) {
          this.$router.push({ path: '/login' })
          return;
        }
        user=JSON.parse(user);
        updateCartPrice({id: id,uid: user.id,number: number}).then(res=>{
          if (res.success) {
            this.$emit('numsClick',{nums:number,price: res.data,index:this.index})
          }
        })
      },
      // position 为关闭时点击的位置
      // instance 为对应的 SwipeCell 实例
      beforeClose({ position, instance }) {
        switch (position) {
          case 'cell':
          case 'outside':
            instance.close()
            break
          case 'right':
            this.$dialog
              .confirm({
                message: '确定删除吗？'
              })
              .then(() => {
                this.$emit('handleDelete', this.id)
              })
              .catch(() => {
                instance.close()
              })
            instance.close()
            break
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card__item {
    display: flex;
    flex-direction: row;
    margin: 7px 12px;
    box-shadow:0px 1px 2px rgba(0,0,0,0.16);
    background:rgba(255,255,255,1);
    border-radius:4px;
    .goods{
      padding: 22px 0;
      .goods_header{
        display: flex;
        flex-direction: row;
        .goods_name{
          flex: 1;
          box-sizing: border-box;
          margin-left: 10px;
        }
      }
      .good_sku{
        height: 20px;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        color: #888988;
        background: #f3f3f3;
        padding: 0 5px;
        margin-top: 10px;
      }
      .goods_footer{
        display: flex;
        flex-direction: row;
        margin-top: 15px;
        .goods_price{
          flex: 1;
          font-size:14px;
          font-weight:400;
          color:rgba(254,0,59,1);
        }
        .goods_num{
          width: 100px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/cart/modules/Item.vue